<template>
    <BasicLayout :left="left" :middle="middle" :right="right">
        <template v-slot:right_view>
            <div class="h-outTabs">
                <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selected='selected' :selectedItem="0">
                  <e-tabitems>
                    <e-tabitem :header="headerText1" content="#idv1"></e-tabitem>
                    <e-tabitem :header="headerText2" content="#idv2"></e-tabitem>
                    <e-tabitem :header="headerText3" content="#idv3"></e-tabitem>
                    <e-tabitem :header="headerText4" content="#idv4"></e-tabitem>
                  </e-tabitems>
                </ejs-tab>
            </div>
            <div id="idv1" style="display: none">
              <MonitorTaskLog></MonitorTaskLog>
            </div>
            <div id="idv2" style="display: none">
              <RealtimeCpuMonitor ref='realtimeCpuMonitor'></RealtimeCpuMonitor>
            </div>
            <div id="idv3" style="display: none">
              <RealtimeMemoryMonitor ref='realtimeMemoryMonitor'></RealtimeMemoryMonitor>
            </div>
            <div id="idv4" style="display: none">
              <RealtimeDiskMonitor ref='realtimeDiskMonitor'></RealtimeDiskMonitor>
            </div>
        </template>
    </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import RealtimeCpuMonitor from './RealtimeCpuMonitor';
import RealtimeMemoryMonitor from './RealtimeMemoryMonitor';
import RealtimeDiskMonitor from './RealtimeDiskMonitor';
import socketInstance from '../../plugins/stompSock';
import MonitorTaskLog from '../../views/monitor/MonitorTaskLog';

export default{
    name: "realtimeMonitor",
    components: {
        MonitorTaskLog,
        BasicLayout,
        RealtimeCpuMonitor,
        RealtimeMemoryMonitor,
        RealtimeDiskMonitor
    },
    data() {
        return {
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Monitor.monitor')}` + '/' + `${this.$t('Monitor.realTimeMonitoring.crumb')}` },
            headerText1: { text: `${this.$t('Monitor.record.titleName')}` },
            headerText2: { text: `${this.$t('Monitor.realTimeMonitoring.CPUUtilization')}` },
            headerText3: { text: `${this.$t('Monitor.realTimeMonitoring.memoryUsage')}` },
            headerText4: { text: `${this.$t('Monitor.realTimeMonitoring.diskUsage')}`},
            websocketSetting: [
                { topic: '/user/#/realTimeMonitoring', clientId: 'monitoring', callback: this.websocketCallback }
            ],
        };
    },
    methods: {
        selected(args){
            const index = args.selectedIndex;
            if (index === 0) {
            } else {
            }
        },
        websocketInit() {
            socketInstance.init(this.websocketSetting);
        },
        websocketCallback(msg) {
            const data = JSON.parse(msg.body);
            const CPUUtilization = data.CPUUsage;
            this.$refs.realtimeCpuMonitor.getMonitorData(CPUUtilization);
            const memoryTotal = data.memoryTotal;
            const memoryUsage = data.memoryUsage;
            const memoryUsageRatio = data.memoryUsageRatio;
            this.$refs.realtimeMemoryMonitor.getMonitorData(memoryTotal, memoryUsage, memoryUsageRatio);
            const diskTotal = data.diskTotal;
            const diskUsage = data.diskUsage;
            const diskUtilization = data.diskUsageRatio;
            this.$refs.realtimeDiskMonitor.getMonitorData(diskTotal, diskUsage, diskUtilization);
        }
    },
    mounted() {
        this.websocketInit();
    },
    beforeDestroy() {
        for (let i = 0; i < this.websocketSetting.length; i++) {
            socketInstance.stopReceiveTopicMsg(this.websocketSetting[i].clientId, this.websocketSetting[i].topic);
        }
    }
}
</script>
